import React from 'react';
import styles from './TimelineWidget.module.scss';

const TimelineWidgetLoading: React.FC = () => (
  <div className={styles.container}>
    <div className={styles.loadingPlaceholder}>
      <div className={styles.scale}>
        {[...Array(7)].map((_, i) => (
          <div key={i} className={styles.block} />
        ))}
      </div>
      <div className={styles.bars}>
        {[...Array(17)].map((_, i) => (
          <div key={i}>
            <div className={styles.bar} />
            <div className={styles.block} />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default TimelineWidgetLoading;
